/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import dragula from 'react-dragula';
import 'dragula/dist/dragula.min.css';
import {find, isEmpty, propEq} from 'ramda';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faObjectGroup, faSpinner} from '@fortawesome/free-solid-svg-icons'
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../../components/general/flex-root';
import Header from '../../../components/dashboard/grid/header';
import Overlay from '../../../components/dashboard/grid/overlay';
import ColumnItem from '../../../components/dashboard/grid/item';
import ColumnError from '../../../components/dashboard/grid/errortracking';
import {getworkstepcount, resetOverlay, setOverlay, tasksSelect, tasksUpdate} from '../../../store/tasks/actions';
import {
    getAllTaskWorkSteps, getCustomFilter, getErpFilter, getLoadingTasks, getOrderFilter,
    getTaskColumnHeadings,
    getTasksCurrent,
    getWorkstepcount
} from '../../../store/tasks/selectors';
import {errorSelect} from "../../../store/quality/actions";
import {getCurrentError} from "../../../store/quality/selectors";
import {
    displayshop,
    extendtileinformation,
    getAuthUser,
    isDispo,
    isQuality,
    noworkplace
} from "../../../store/auth/selectors";
import {dispoGetDepartments, dispoGetUser, dispoTaskUpdate} from "../../../store/dispo/actions";
import compose from "ramda/src/compose";
import {withRouter} from "react-router-dom";

const ColumnsWrapper = styled.div`
    margin-left: 20px;
    margin-right: 20px;
	display:flex;
	flex: 1 1;
`;

const Message = styled.div`
	width: 250px;
	text-align: center;
	margin: auto auto auto auto;
`;

const Column = styled(FlexRootWrapper)`
	width: 20%;
	max-width: 20%;

	& + div {
		padding-left: 1px;
		border-left: 1px solid #9d9d9d;
	}
`;

class Grid extends React.Component {
    constructor() {
        super();

        const drake = dragula();

        drake.on('drop', this.handleItemDrop);
        this.state = {drake};
    }

    toggleModal = () => {
        const {setOverlay} = this.props;
        setOverlay(null, 'completeTask');
    };

    handleItemDrop = (el, target, source, sibling) => {
        this.state.drake.cancel(true);

        const {tasks, columns, dispoTaskUpdate, isDispo} = this.props;
        const newVal = target.id;
        const task = tasks.find((element) => {
            return element.id.toString() === el.id.toString();
        });

        //const task = find(propEq('id', el.id))(tasks);
        const nextTask = sibling
            ? find(propEq('id', sibling.id))(tasks)
            : null;

        const priority = this.getTaskPriority(task, nextTask, columns[newVal]);

        if (isDispo) {
            dispoTaskUpdate(task.id, {date: newVal, priority});
        }

    };

    handleItemClick = (task) => {
        const {allowedStatuses, tasksSelect, history} = this.props;
        if (allowedStatuses.length === 0 || allowedStatuses.indexOf(task.status) > -1) {
            tasksSelect(task);
        }
        if (task.status === 'in-progress' && task.workgroup !== '' && task.workgroup !== null) {
            history.push('/dashboard/working');
            tasksSelect(task);
        }
    };

    getTaskPriority(task, nextTask, tasks) {
        if (isEmpty(tasks)) {
            return task.priority;
        }

        return nextTask
            ? parseInt(nextTask.priority, 10) - 1
            : parseInt(tasks[tasks.length - 1].priority, 10) + 1;
    }

    appendContainer = (container) => {
        const {drake} = this.state;

        drake.containers.push(container);
    };

    render() {
        const {
            allowedStatuses,
            tasksSelect,
            headings,
            columns,
            current,
            taskComponent,
            errortracking,
            errorSelect,
            currentError,
            workstepcount,
            isDispo,
            noworkplace,
            allWorkSteps,
            extendtileinformation,
            tasks,
            erpFilter,
            orderFilter,
            customFilter,
            loadingTasks,
        } = this.props;

        const Task = taskComponent;
        const tasksIsEmpty = isEmpty(tasks);
        return (
            !isEmpty(current) || !isEmpty(currentError)
                ? <Task/>
                : <FlexRootWrapper>
                    <Overlay/>
                    {headings && <Header items={headings}/>}
                    {tasksIsEmpty && <ColumnsWrapper>
                        {(isEmpty(customFilter) || customFilter.value === '')
                            ? <Message>{loadingTasks ? <FontAwesomeIcon size="lg" icon={faSpinner} spin/> : <span> Es wurden keine Aufgaben gefunden.</span>}</Message>
                            : <Message>{loadingTasks ? <FontAwesomeIcon size="lg" icon={faSpinner} spin/> : <span>Es wurden keine Aufgaben mit dem Filter '{customFilter.value}' gefunden.</span>}</Message>}

                    </ColumnsWrapper>}
                    {!tasksIsEmpty && <ColumnsWrapper>
                        {Object.entries(columns).map(([id, tasks]) => (
                            <Column
                                innerRef={this.appendContainer}
                                key={`col-${id}`}
                                id={`${id}`}
                            >
                                {!errortracking && tasks && tasks.map((task, index) => (
                                    <ColumnItem
                                        task={task}
                                        workstepcount={workstepcount}
                                        key={`col-${id}-item-${index}`}
                                        handleClick={() => this.handleItemClick(task)}
                                        isDispo={isDispo}
                                        noworkplace={noworkplace}
                                        allWorkSteps={allWorkSteps}
                                        extendtileinformation={extendtileinformation}
                                    />
                                ))}

                                {errortracking && tasks && tasks.map((task, index) => (
                                    <ColumnError
                                        task={task}
                                        workstepcount={workstepcount}
                                        key={`col-${id}-error-${index}`}
                                        handleClick={() => errorSelect(task)}
                                        noworkplace={noworkplace}
                                        allWorkSteps={allWorkSteps}
                                    />
                                ))}
                            </Column>
                        ))}
                    </ColumnsWrapper>}
                </FlexRootWrapper>
        );
    }
}

export default compose(connect(
    (state) => (
        {
            headings: getTaskColumnHeadings(state),
            current: getTasksCurrent(state),
            currentError: getCurrentError(state),
            overlay: state.tasks.overlay,
            workstepcount: getWorkstepcount(state),
            noworkplace: noworkplace(state),
            allWorkSteps: getAllTaskWorkSteps(state),
            extendtileinformation: extendtileinformation(state),
            erpFilter: getErpFilter(state),
            orderFilter: getOrderFilter(state),
            customFilter: getCustomFilter(state),
            loadingTasks: getLoadingTasks(state),
        }),
    {
        tasksSelect,
        tasksUpdate,
        setOverlay,
        errorSelect,
        dispoTaskUpdate,
    }), withRouter)(Grid);



// WEBPACK FOOTER //
// ./src/containers/dashboard/grid/index.js